import React from 'react';
import styled from 'styled-components';
import { TextLink } from '@sdir/sds';
import { ErrorMessage } from '@sdir/utilities/lib/components';

interface RestrictedContentInfoProps {
  description?: string;
  linkText?: string;
  onBack?: () => void;
  title: string;
}

const RestrictedContentInfo: React.FC<RestrictedContentInfoProps> = ({
  description,
  linkText,
  onBack,
  title,
}) => {
  return (
    <WrapperNoAccess>
      {linkText && onBack && <TextLink text={linkText} click={onBack} />}
      <ErrorMessage title={title} error={description || ''} />
    </WrapperNoAccess>
  );
};

export default RestrictedContentInfo;

const WrapperNoAccess = styled.div`
  max-width: 600px;
  margin: 60px 0;

  & > button {
    margin-bottom: 15px;
  }
`;
